"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.config.display.default.prompts.button': '不确定问什么？试试我们的建议！',
    'chat.config.button.label.text': '发送提示',
    'chat.config.cancel.button.label.text': '取消生成',
    'chat.config.voice.button.label.text': 'voice input',
    'chat.config.voice.rec.button.label.text': '正在听语音输入',
    'chat.config.input.newline.helper': ' 换行',
    'chat.config.autocomplete.styles.helper': ' 样式',
    'chat.config.autocomplete.projects.helper': ' 项目',
    'chat.config.autocomplete.knowledge.helper': ' 知识',
    'chat.config.live_chat.button.label.text': 'Live chat',
    'chat.config.input.placeholder': '输入您的问题，例如："我如何能帮助您？"',
    'chat.config.user.is.bot': '支持助手',
    'chat.config.reset.button.label.text': 'X',
    'chat.config.reset.button.title.text': '重置当前问题',
    'chat.config.reset.chat.button.title': '重置聊天',
    'chat.config.copy.response.button.label.text': '复制回复',
    'chat.config.copied.successfully.message': '回复已复制！',
    'chat.config.follow.up.questions.label.text': '您也可以问...',
    'chat.config.show.thought.process.button.label.text': '显示思考过程',
    'chat.config.hide.thought.process.button.label.text': '隐藏思考过程',
    'chat.config.loading.indicator.text': '请稍候。我们正在搜索并生成答案...',
    'chat.config.loading.text': '加载中...',
    'chat.config.api.error.message': '抱歉，我们遇到了一些问题。请稍后再试。',
    'chat.config.invalid.request.error': '无法为此查询生成答案。请修改您的问题并重试。',
    'chat.config.thought.process.label': '思考过程',
    'chat.config.support.context.label': '支持上下文',
    'chat.config.reasoning.label': '推理',
    'chat.config.citations.label': '了解更多：',
    'chat.config.citations.tab.label': '引用',
    'chat.config.branding.logo.alt': '品牌标志',
    'chat.config.branding.headline': '欢迎使用我们品牌的支持助手',
    'chat.config.show.chat.history.label': '显示聊天历史',
    'chat.config.hide.chat.history.label': '隐藏聊天历史',
    'chat.config.chat.history.footer.text': '显示过去{MAX_CHAT_HISTORY}次对话',
    'chat.config.web.search.checkbox.label': '使用网页搜索',
    'chat.config.deep.search.checkbox.label': '使用深度搜索',
    'chat.config.adv.prompt.checkbox.label': '高级提示',
    'chat.config.autocomplete.style.selected': '样式 "{name}" 已添加',
    'chat.config.autocomplete.project.selected': '项目 "{name}" 已添加',
    'chat.config.autocomplete.knowledge.selected': '知识 "{name}" 已添加',
    'chat.config.add.kdb.button.label.text': '添加到知识库',
};
